<template>
  <v-dialog persistent v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        <v-layout class="mx-n2">
          <v-flex>
            <div>Edit Enity Type</div>
          </v-flex>
          <v-flex text-right>
            <v-btn icon @click="dialog = false">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="px-4 mb-3">
        <v-flex>
          <v-layout>
            <v-flex>
              <div class="subtitle-2 mb-1">
                What's the name of the Entity Type?
              </div>
              <v-text-field
                v-model="name"
                hide-details
                dense
                outlined
                placeholder="Entity Type Name"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    details: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      dialog: false,
      name: "",

      id: "",
    };
  },
  computed: {
    changeFields() {
      return {
        name: this.name,
        id: this.id,
      };
    },
  },
  methods: {
    ...mapActions({
      updateEntityType: "$_home/updateContent",
      getEntityTypes: "$_home/getContent",
    }),
    toggleDialog(details) {
      this.dialog = !this.dialog;
      console.log("opening edit");
      if (this.dialog) {
        console.log(this.details);
        this.name = details.name;
        this.id = details.id;
      }
    },
    cancel() {
      this.name = "";
      this.dialog = false;
    },
    save() {
      console.log("Save entity type: ", this.changeFields);
      this.updateEntityType({
        details: this.changeFields,
        collection: "entityTypes",
        type: "Entity Type",
      }).then(() => {
        this.cancel();
        this.getEntityTypes({
          collection: "entityTypes",
          mutation: "updateEntityTypes",
        });
      });
    },
  },
};
</script>

<style>
</style>